// Composables
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { Capacitor } from "@capacitor/core";
import Home from '@/views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    redirect: '/',
    children: [
      {
        path: '',
        name: 'Home',
        // Home soll nich lazy loaded sein - sondern immer da!
        component: Home,
      },
      {
        path: 'ALLLogin',
        name: 'Login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('@/views/ALLLogin.vue'),
      },
      {
        path: '/AllWelcome',
        name: 'AllWelcome',
        component: () => import('@/views/AllWelcome.vue'),
      },
      // SoftTerm Ordner
      {
        path: '/SoftTermSalden',
        name: 'SoftTermSalden',
        component: () => import(/* webpackChunkName: "salden" */ '@/views/SoftTerm/Salden.vue'),
        props: true
      },
      {
        path: '/SoftTermSoftTerm',
        name: 'Soft- Terminal',
        component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/SoftTerm.vue'),
        props: true,
      },

      {
        path: '/SoftTermBDE',
        name: 'SoftTermBDE',
        component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/SoftTermBDE.vue'),
        props: true,
      },
      {
        path: '/StempelEditBDE',
        name: 'StempelEditBDE',
        component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/StempelEditBDE.vue'),
        props: true,
      },
      {
        path: '/SoftTermStempelEdit',
        name: 'SoftTermStempelEdit',
        component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/StempelEdit.vue'),
        props: true,
      },
      {
        path: '/SoftTermReisenGrenzuebertritt',
        name: 'SoftTermReisenGrenzuebertritt',
        component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/Reisen/Grenzuebertritt.vue'),

      },
      // {
      //   path: '/SoftTermReisenDienstReiseEnde',
      //   name: 'SoftTermReisenDienstReiseEnde',
      //   component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/Reisen/DienstReiseEnde.vue'),
      //   props: true,
      // },
      {
        path: '/SoftTermProjektstundenProjektstunden',
        name: 'SoftTermProjektstundenProjektstunden',
        component: () => import(/* webpackChunkName: "softTerm" */'@/views/SoftTerm/Projektstunden/Projektstunden.vue'),
        props: true,
      },
      {
        path: '/SoftTermBuchungen',
        name: 'SoftTermBuchungen',
        component: () => import(/* webpackChunkName: "buchungen" */'@/views/SoftTerm/Buchungen.vue'),
      },
      {
        path: '/SoftTermAnwesenheiten',
        name: 'Anwesenheiten',
        component: () => import(/* webpackChunkName: "anwesenheiten" */'@/views/SoftTerm/Anwesenheiten.vue'),
      },

      {
        path: '/PzePersoenlichPlanungenAbwesenheiten',
        name: 'PzePersoenlichPlanungenAbwesenheiten',
        component: () => import(/* webpackChunkName: "abwesenheiten" */'@/views/PZE/persoenlich/Planungen/Abwesenheiten.vue'),
      },
      {
        path: 'PzePersoenlichPlanungenTemplatesDialogDetailAntrag',
        name: 'PzePersoenlichPlanungenTemplatesDialogDetailAntrag',
        component: () => import(/* webpackChunkName: "Detail Antrag" */'@/views/PZE/persoenlich/Planungen/Templates/DialogDetailantrag.vue'),
      },
      {
        path: 'PzePersoenlichPlanungenTemplatesDialogAntrag',
        name: 'PzePersoenlichPlanungenTemplatesDialogAntrag',
        component: () => import(/* webpackChunkName: "Dialog Antrag" */'@/views/PZE/persoenlich/Planungen/Templates/DialogAntrag.vue'),
      },
            {
        path: 'PzePersoenlichPlanungenAntraege',
        name: 'PzePersoenlichPlanungenAntraege',
        component: () => import('@/views/PZE/persoenlich/Planungen/Antraege.vue'),
      },
      {
        path: 'PzePersoenlichPlanungenTemplatesDialogDienstplan',
        name: 'PzePersoenlichPlanungenTemplatesDialogDienstplan',
        component: () => import(/* webpackChunkName: "anwesenheiten" */'@/views/PZE/persoenlich/Planungen/Templates/DialogDienstplan.vue'),
      },
      {
        path: 'PzePersoenlichPlanungenTemplatesStempelungen',
        name: 'PzePersoenlichPlanungenTemplatesStempelungen',
        component: () => import(/* webpackChunkName: "Stempelungen" */'@/views/PZE/persoenlich/Planungen/Templates/Stempelungen.vue'),
      },
      {
        path: '/PzeWfVorgesetzterFreigabenAbwesenheitenMitarbeiter',
        name: 'Abwesenheiten Mitarbeiter',
        component: () => import(/* webpackChunkName: "abwesenheiten MA" */'@/views/PZE/WFVorgesetzter/Freigaben/AbwesenheitenMitarbeiter.vue'),
      },
      {
        path: '/PzeWfVorgesetzterFreigabenTemplateStempelungen',
        name: 'Stempelungen',
        component: () => import(/* webpackChunkName: "monatl.Freigabe" */'@/views/PZE/WFVorgesetzter/Freigaben/Template/Stempelungen.vue'),
      },
      {
        path: '/PzeWfVorgesetzterFreigabenTemplateMaUest',
        name: 'MA Überstunden',
        component: () => import(/* webpackChunkName: "maUest" */ '@/views/PZE/WFVorgesetzter/Freigaben/Template/MAUest.vue'),
      },
      {
        path: '/RkMitarbeiterReiseUebersicht',
        name: 'Reise Übersicht',
        component: () => import(/* webpackChunkName: "reise übersicht" */'@/views/RK/Mitarbeiter/ReiseUebersicht.vue'),
      },
      {
        path: '/PzePersoenlichWfWorkflowMa',
        name: 'Monatsprüfung Mitarbeiter',
        component: () => import(/* webpackChunkName: "monatsprüfung" */'@/views/PZE/persoenlich/WF/WorkflowMa.vue'),
      },

      {
        path: '/RkMitarbeiterSonstigeBelege',
        name: 'sonstige Belege Mitarbeiter',
        component: () => import(/* webpackChunkName: "sonstige Belege" */'@/views/RK/Mitarbeiter/sonstigeBelege.vue'),
      },
      {
        path: '/DashboardAufgabenTemplatedPagePers',
        name: 'Dashboard Persönlich',
        component: () => import(/* webpackChunkName: "persönliches DS" */'@/components/dashboard/AufgabenTemplatedPagePers.vue'),
      },
      {
        path: '/DashboardAufgabenTemplatedPage',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "VG Dashboard" */'@/components/dashboard/AufgabenTemplatedPage.vue'),
      },
      // Base - Ordner
      {
        path: '/persEinstellungen',
        name: 'persEinstellungen',
        component: () => import(/* webpackChunkName: "persEinst" */ '@/views/Base/PersEinstellungen.vue'),
      },
      {
        path: '/BemerkungAnwesenheiten',
        name: 'Bemerkung An- Abwesenheitsliste',
        component: () => import(/* webpackChunkName: "persEinst" */ '@/views/Base/BemerkungAnwesenheiten.vue'),
      },
      {
        path: '/password',
        name: 'password',
        component: () => import('@/views/Base/Password.vue'),
      },
      {
        // muss zwingend vorhanden sein!
        path: '/BaseStammMaske',
        name: 'BaseStammMaske',
        component: () => import('@/views/Base/StammMaske.vue'),
        props: true
      },
      {
        path: '/stammListe',
        name: 'StammListe',
        component: () => import('@/views/Base/StammListe.vue'),
        props: true
      },
      {
        path: '/BaseAppConnect',
        name: 'BaseAppConnect',
        component: () => import(/* webpackChunkName: "appConnect" */ '@/views/Base/AppConnect.vue'),
      },
      // {
      //   path: '/BaseBenutzerMitarbeiter',
      //   name: 'BaseBenutzerMitarbeiter',
      //   component: () => import(/* webpackChunkName: "appConnect" */ '@/views/Base/BenutzerMitarbeiter.vue'),
      // },
      {
        path: '/BaseSystemInfo',
        name: 'BaseSystemInfo',
        component: () => import(/* webpackChunkName: "systemInfo" */ '@/views/Base/SystemInfo.vue'),
      },
      {
        path: '/BaseApiAufruf',
        name: 'BaseApiAufruf',
        component: () => import(/* webpackChunkName: "api" */ '@/views/Base/ApiAufruf.vue'),
      },
      {
        // wichtig sonst geht die Maske nicht auf im UserMenu
        path: '/BasePassword',
        name: 'BasePassword',
        component: () => import(/* webpackChunkName: "password" */'@/views/Base/Password.vue'),
      },

      // components
      {
        path: '/EditStamm',
        name: 'EditStamm',
        component: () => import(/* webpackChunkName: "editStamm" */ '@/components/EditStamm.vue'),
        // props: route => ({ siteData: route.params.siteData }),
      },
      {
        path: '/DashboardChartsDetailsPopUp',
        name: 'DashboardChartsDetailsPopUp',
        component: () => import(/* webpackChunkName: "DetailsPopup" */ '@/components/dashboard/Charts/DetailsPopUp.vue'),

      },
      {
        path: '/BaseHauptschirm',
        name: 'BaseHauptschirm',
        component: () => import(/* webpackChunkName: "stammBaseList" */ '@/views/Base/HSTreeView.vue'),
        props: true
      },
      {
        path: '/baseSyncSchedule',
        name: 'baseSyncSchedule',
        component: () => import(/* webpackChunkName: "baseSchedule" */ '@/components/baseSyncSchedule.vue'),
        props: true
      },

      {
        path: '/VTimeLineMonth',
        name: 'VTimeLineMonth',
        component: () => import(/* webpackChunkName: "TimeLineDay" */ '@/components/common/VTimeLineMonth.vue'),
      },
      {
        path: '/AnzeigeReiseTimeLine',
        name: 'AnzeigeReiseTimeLine',
        component: () => import('@/views/RK/Mitarbeiter/Template/AnzeigeReiseTimeLine.vue'),
        props: true
      },
      // {
      //   path: '/EditKMErfassung',
      //   name: 'EditKMErfassung',
      //   component: () => import('@/views/RK/Mitarbeiter/EditKmErfassung.vue'),
      //   props: true
      // },
      {
        path: '/sonstigeBelege',
        name: 'sonstigeBelege',
        component: () => import('@/views/RK/Mitarbeiter/sonstigeBelege.vue'),
        props: true
      },

      {
        path: '/RkAdminMonatsabschluss',
        name: 'RkAdminMonatsabschluss',
        component: () => import('@/views/RK/Admin/Monatsabschluss.vue'),
      },
      {
        path: '/RkAdminUeberleitung',
        name: 'RkAdminUeberleitung',
        component: () => import('@/views/RK/Admin/Ueberleitung.vue'),
      },
      {
        path: '/RkAdminAuszahlung',
        name: 'RkAdminAuszahlung',
        component: () => import('@/views/RK/Admin/Auszahlung.vue'),
      },
      {
        path: '/PzeWfVorgesetzterFreigabe',
        name: 'VG Freigabe Mitarbeiter',
        component: () => import(/* webpackChunkName: "freigabe" */'@/views/PZE/WFVorgesetzter/Freigabe.vue')
      },
      {
        path: '/RkMitarbeiterEditKostenersatzGrid',
        name: 'sonstige Belege',
        component: () => import(/* webpackChunkName: "freigabe" */'@/views/RK/Mitarbeiter/EditKostenersatzGrid.vue')
      },

      {
        path: '/TestNode',
        name: 'Test - Node',
        component: () => import('@/views/Test/TestNode.vue'),
        props: true
      },
         {
        path: '/Bewerbung',
        name: 'Bewerbung',
        component: () => import('@/views/PV/persoenlich/Bewerbung/Bewerbung.vue'),
      }
        ,{
          path: '/BewerbungSummary',
          name: 'BewerbungSummary',
          component: () => import('@/views/PV/persoenlich/Bewerbung/BewerbungSummary.vue'),
        }
    ],
  },
]

// set base URL for the router
// This is important for Capacitor apps to work with the updated web (ending root url "/index.html")

const baseUrl = Capacitor.getPlatform() === "web" ? "/" : window.location.pathname ?? process.env.BASE_URL;

console.log("Router baseUrl:", baseUrl);

function ensureRootPath() {
  const r = router.currentRoute.value;
  if (r.path !== "/") {
    const redirect = (r.query.redirect as string) || r.fullPath;
    router.replace({ path: "/", query: { redirect } }).catch(() => {});
  }
}

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes,
})

ensureRootPath();

export default router
